import api from '../api'; // your Axios instance

export function getHomeImages() {
    return api.get('/home/getHomePageImages');
}

interface HomeImagePayload {
    title: string;
    link: string;
    image: File; // File from input[type="file"]
    mobileImage: File;
  }
  
  export function addHomeImage({ title, link, image, mobileImage }: HomeImagePayload) {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('link', link);
    formData.append('image', image);
    formData.append('mobile_image', mobileImage);
  
    return api.post('/home/addHomePageImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  interface EditHomeImagePayload {
    id: number;
    title: string;
    link: string;
    display_order: number;
    image?: File; // Optional if unchanged
    mobile_image?: File
  }
  
  export function editHomeImage({ id, title, link, display_order, image, mobile_image }: EditHomeImagePayload) {
    const formData = new FormData();
    formData.append('id', String(id));
    formData.append('title', title);
    formData.append('link', link);
    formData.append('display_order', String(display_order));
  
    if (image) {
      formData.append('image', image);
    }

    if (mobile_image) {
      formData.append('mobile_image', mobile_image);
    }
  
    return api.post('/home/editHomePageImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  export function deleteHomeImage(id: number) {
    const formData = new FormData();
    formData.append('id', String(id));

    return api.post('/home/delete', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  
